export default __webpack_public_path__ + "8ecb9b1c7d41d7196375abdc97a53b4b.gif";